"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = require("./Components/Button/Button");
require("./DOM/Document/CreateElement");
require("./DOM/EventTarget/AddDelegateListener");
require("./DOM/EventTarget/AddEventListener");
require("./DOM/EventTarget/AddKeyListener");
require("./DOM/EventTarget/GetEventListeners");
require("./DOM/EventTarget/RemoveEventListeners");
require("./DOM/HTMLElement/AttributeMap");
require("./DOM/HTMLElement/DataMap");
require("./DOM/HTMLElement/CheckVisibility");
require("./DOM/HTMLElement/GetFormData");
require("./DOM/HTMLElement/GetHeight");
require("./DOM/HTMLElement/GetPosition");
require("./DOM/HTMLElement/GetWidth");
require("./DOM/HTMLElement/Query");
require("./DOM/HTMLElement/RelativeTo/SetRelativeTo");
require("./DOM/HTMLElement/SetFormData");
require("./DOM/HTMLElement/Siblings");
require("./DOM/HTMLInputElement/ParseInt");
require("./DOM/HTMLInputElement/StateChange");
require("./DOM/HTMLSelectElement/SetOptions");
require("./DOM/Body");
require("./DOM/Promise");
require("./DOM/ShadowRoot");
const Framework_1 = require("./Framework/Framework");
const Objects_1 = require("./Utility/Objects");
const DependencyContainer_1 = require("./Framework/DependencyContainer");
class Druid {
    /**
     * Configure should only be called once at the boot-up of the library
     */
    static configure(config, environment = 'prod') {
        if (Druid.configured && environment === 'prod') {
            throw new Error('Druid.configure should only be called `once`');
        }
        Druid.config = Objects_1.default.merge(Objects_1.default.merge({}, Druid.DEFAULT_CONFIG), config);
        Druid.validateConfig(Druid.config, environment);
        // register WebComponents, only possible once
        if (Druid.configured === false) {
            window.customElements.define(Druid.config.button.tag, Button_1.default);
        }
        Druid.configured = true;
    }
    /**
     * @internal
     */
    static configuration() {
        var _a;
        return (_a = Druid.config) !== null && _a !== void 0 ? _a : Druid.DEFAULT_CONFIG;
    }
    /**
     * @internal
     */
    static dispose(element) {
        if (element !== undefined && Druid.framework !== undefined) {
            Druid.framework.unregisterView(element);
        }
        document.body.dispatchEvent(new CustomEvent(Druid.DISPOSE_EVENT, { cancelable: false, bubbles: false, detail: element }));
    }
    static addDefaultRequestHeader(key, value) {
        Druid.defaultRequestHeaders[key] = value;
    }
    static getDefaultRequestHeaders() {
        // return a clone of the object, to prevent accidental modification
        return { ...Druid.defaultRequestHeaders };
    }
    /**
     * Listen globally to any and all http responses
     */
    static addHttpResponseHandler(handler) {
        Druid.httpResponseHandlers.push(handler);
    }
    /**
     * @internal
     */
    static handleHttpResponse(response) {
        for (const handler of Druid.httpResponseHandlers) {
            handler(response);
        }
    }
    /**
     * @internal
     */
    static getViewFramework() {
        var _a;
        return ((_a = Druid.framework) !== null && _a !== void 0 ? _a : (Druid.framework = new Framework_1.default()));
    }
    /**
     * @internal
     */
    static getContainer() {
        var _a;
        return ((_a = Druid.dependencyContainer) !== null && _a !== void 0 ? _a : (Druid.dependencyContainer = new DependencyContainer_1.default()));
    }
    static validateConfig(config, environment) {
        // istanbul ignore else
        if (environment === 'test') {
            return;
        }
        // istanbul ignore next
        if (config.translations.errorInputInvalid === '') {
            throw new Error('Druid.translations.errorInputInvalid is not set');
        }
        // istanbul ignore next
        if (config.translations.mandatoryField === '') {
            throw new Error('Druid.translations.mandatoryField is not set');
        }
    }
}
Druid.DISPOSE_EVENT = 'dispose';
Druid.DEFAULT_FORM_ELEMENTS = ['input', 'select', 'textarea'];
Druid.DEFAULT_FILE_INPUTS = ['input[type=file]'];
Druid.DEFAULT_CONFIG = {
    button: { tag: 'dr-button' },
    form: {
        elements: Druid.DEFAULT_FORM_ELEMENTS,
        fileInputs: Druid.DEFAULT_FILE_INPUTS,
        className: 'dr-form',
        invalidInputClass: 'dr-form--invalid-input'
    },
    formIf: { attribute: 'dr-form-if' },
    icon: { className: 'dr-icon', loading: 'dr-icon--loading' },
    translations: { mandatoryField: '', errorInputInvalid: '' },
    scrollLock: true
};
Druid.configured = false;
Druid.httpResponseHandlers = [];
Druid.defaultRequestHeaders = {};
exports.default = Druid;
//# sourceMappingURL=Druid.js.map